import { action } from "satcheljs";

export interface MarkItemsAsReadStoreUpdateActionMessage {
    itemIds: string[];
    isReadValue: boolean;
    isExplicit: boolean;
    tableViewId: string;
}

const defaultExport: (itemIds: string[], isReadValue: boolean, isExplicit: boolean, tableViewId: string) => MarkItemsAsReadStoreUpdateActionMessage = action("MARK_ITEMS_AS_READ_STORE_UPDATE", (itemIds: string[], isReadValue: boolean, isExplicit: boolean, tableViewId: string): MarkItemsAsReadStoreUpdateActionMessage => {
    return {
        itemIds,
        isReadValue,
        isExplicit,
        tableViewId,
    };
});
export default defaultExport;
